import { render, staticRenderFns } from "./checksList.vue?vue&type=template&id=21c1198e&scoped=true&"
import script from "./checksList.vue?vue&type=script&lang=js&"
export * from "./checksList.vue?vue&type=script&lang=js&"
import style0 from "./checksList.vue?vue&type=style&index=0&id=21c1198e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c1198e",
  null
  
)

export default component.exports